import { render, staticRenderFns } from "./CardMyIncidentsTable.vue?vue&type=template&id=039cba6e&"
import script from "./CardMyIncidentsTable.vue?vue&type=script&lang=js&"
export * from "./CardMyIncidentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports